/*
 * @Description: 单位管理store
 * @Author: wangzhenxin (834529118@qq.com)
 * @Date: 2019-05-30 16:04:04
 * @LastEditTime: 2019-05-30 16:18:40
 * @LastEditors: wangzhenxin (834529118@qq.com)
 */
import {
  getDepartmentManagementTree,
  addDepartmentManagement,
  deleteDepartmentManagement,
} from './service'

const state = {
  DepartmentDict: [],
}

const mutations = {
  setData (state, payload) {
    Object.assign(state, payload)
  },
}

const actions = {
  /**
   * 处理上级部门级联value值,当前的值与列表进行对比取出其所有的父元素
   */
  handleCodeList (store, { data, _code }) {
    let codeData = ''

    const _data = data

    initCode(data, _code)

    function initCode (data, _code) {
      data.filter(val => {
        if (val.code === _code) {
          codeData = `${val.code},${codeData}`
          if (val.superDep) {
            initCode(_data, val.superDep)
          }
        } else if (val.childs && val.childs.length) {
          initCode(val.childs, _code)
        }
      })
    }
    return codeData.split(',').filter(r => r)
  },
  /**
   * 获取部门列表树
   * @param {*} store
   * @param {*} params
   */
  async getDepartmentManagementTree (store, params) {
    return getDepartmentManagementTree(params)
  },
  /**
   * 新增部门
   * @param {*} store
   * @param {*} params
   */
  async addDepartmentManagement (store, params) {
    return addDepartmentManagement(params)
  },
  /**
   * 删除部门
   * @param {*} store
   * @param {*} params
   */
  async deleteDepartmentManagement (store, params) {
    return deleteDepartmentManagement(params)
  },
}

const getters = {}

const DepartmentManagement = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}

export default DepartmentManagement
